import de from './locales/de';

const messages = {
  de,
};

export default messages;
